import req from './http.js'

// 登入
export const apiGetApiLogReport = params => req('post', '/reservation/integration/getApiLogReport', params)